// removed by extract-text-webpack-plugin
module.exports = {"Nav__Portal__item":"Nav__Portal__item","navPortalItem":"Nav__Portal__item","Nav__Portal__item--home":"Nav__Portal__item--home","navPortalItemHome":"Nav__Portal__item--home"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/__components__/Nav.scss
// module id = 575
// module chunks = 0